export const QUESTION_TYPES = {
  multipleChoice: "mc-generic", // From ka
  multipleChoiceCode: "mc-code",
  blockCodeSelection: "mc-block",
  singleLineCodeSelection: "mc-line",
};
